export default "__VITE_ASSET__xFtg9N6g__"